import * as React from "react";
import { makeStyles, useTheme, Theme } from '@material-ui/core/styles';
import { Caption } from "../../atoms/views/Caption";
import { IDefaultViewProps } from "./IDefaultViewProps";
import * as GirIcons from "../../atoms/icons/GirIcon";
import { useTranslation } from 'react-i18next';



export enum GirStatusOptions {
    Geregistreerd,
    NogTeRegistreren,
    Disabled
}

// All the incoming values
interface IProps {

}

// Outgoing functions
interface IDispatch {

}

// Actual Component
export type AllProps = IProps & IDispatch & IDefaultViewProps<GirStatusOptions>;
export const GirStatus = (props: AllProps) => {
    const classes = useStyles(useTheme());
    const { t: tDatatypes } = useTranslation('datatypes');
    const label = props.label || tDatatypes('girStatusLabel') || "GIR Status";

    const icon = (() => {
        switch (props.value) {
            case GirStatusOptions.Geregistreerd:
                return <GirIcons.GirIcon />;
            case GirStatusOptions.NogTeRegistreren:
                return <GirIcons.GirToRegisterIcon color={"disabled"} />;
            default:
                return <GirIcons.GirDisabledIcon color={"disabled"} />;
        }
    })();

    const text = (() => {
        switch (props.value) {
            case GirStatusOptions.Geregistreerd:
                return tDatatypes('girStatusGeregistreerd');
            case GirStatusOptions.NogTeRegistreren:
                return tDatatypes('girStatusNogTeRegistreren');
            default:
                return tDatatypes('girStatusDisabled');
        }
    })();

    return (<Caption {...props} caption={label} icon={icon}>
        
        {text}
        
        </Caption>);
}

// CSS
const useStyles = makeStyles((theme: Theme) => ({ }));